// Formats a cents amount as a dollar string for the pricing calculator.
//
// Pricing psychology: the headline price passes `grouping: false` so the
// number reads smaller (e.g. `1299` instead of `1,299`). Secondary amounts
// like the annual savings keep grouping so the savings still read big.
export function formatDollars(cents, { grouping = true } = {}) {
  const dollars = cents / 100
  return dollars.toLocaleString('en-US', {
    minimumFractionDigits: dollars % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
    useGrouping: grouping,
  })
}
